export const subscriptionTypePremium = 'premium'
export const subscriptionTypePremiumPro = 'premium_pro'
export enum Platform {
  unknown = 'unknown',
  stripe = 'stripe',
  apple = 'apple',
  google = 'google',
}

export enum SubscriptionContractStatus {
  unknown = 'unknown',
  active = 'active',
  cancelled = 'cancelled',
  updateInProgress = 'updateInProgress',
  expired = 'expired',
  scheduled = 'scheduled',
}

export const toEnum =
  <T extends string>(enumObj: Record<string, T>, value: any, fallback: T): T =>
    Object.values(enumObj).includes(value) ? value : fallback
